

import { adminApi } from "src/api"
import { ApiControllers } from "src/api/config"

const analyticsYearsLu=(controller)=>{
  return adminApi.get(ApiControllers.dashboardController+`${controller}`)
}

const analyticsExperience=(controller,year)=>{
    return adminApi.get(ApiControllers.dashboardController+`${controller}/${year}`)
}

const analyticsMovementChart=(controller,year)=>{
    return adminApi.get(ApiControllers.dashboardController+`${controller}/${year}`)
}




const apiCallsForBlades ={analyticsYearsLu,analyticsExperience,analyticsMovementChart}

export default apiCallsForBlades